<template>
  <w-popup-show :state="state" @handleClose="handleClose">
    <div slot="content" class="mailing-content" @touchmove.prevent>
      <div class="close">
        <i class="iconfont iconx" @click="handleClose" />
      </div>
<!--      <div class="close" v-else>-->
<!--        <i class="iconfont iconx" />-->
<!--        <div class="subscribe-con">-->
<!--          <WechatOpenSubscribe :templateIds="templateIds" @handleClick="subscribeCloseClick">-->
<!--            <template slot="subscribe-slot">-->
<!--              <script type="text/wxtag-template">-->
<!--                <style>-->
<!--                  .btn2 {-->
<!--                    width: 100%;-->
<!--                    height: 100px;-->
<!--                  }-->
<!--                </style>-->
<!--                <div class="btn2">可以聊</div>-->
<!--              </script>-->
<!--            </template>-->
<!--          </WechatOpenSubscribe>-->
<!--        </div>-->
<!--      </div>-->
      <div class="header">
        <div class="text">
          <img src="https://files.wondercv.com/mobile/cvs/mailing-success.png">
          <p>投递成功</p>
        </div>
        <div class="source">{{source}}</div>
      </div>
      <div class="correlation">
        相似职位
      </div>
      <div class="scroll-list-wrap">
        <cube-scroll ref="scroll" :data="postList">
          <div class="post-item" v-for="(item, index) in postList" :key="index">
            <div class="option">
              <i class="iconfont iconwancheng" style="font-size: 22px" @click="handleClickSelect(item.token)"
                 v-if="selectTokens.includes(item.token)"></i>
              <div class="not-select" @click="handleClickSelect(item.token)" v-else></div>
            </div>
            <div class="_box_1" @click="handleClickToDetail(item)">
              <div class="item-title">
                <p>{{item.job_post}}</p>
                <p>{{item.display_salary}}</p>
              </div>
              <div class="item-tags">
                <div class="tag">{{item.city_names&&item.city_names.length>0?item.city_names.join(','):'全国'}}</div>
                <div class="tag">{{ item.display_experience | experienceFilter }}</div>
                <div class="tag">{{ item.degree_name | degreeFilter }}</div>
              </div>
              <div class="company">
                <img :src="item.company_logo" alt="">
                <p>{{item.company_nick_name}}</p>
              </div>
            </div>
          </div>
          <div style="height: 50px"></div>
        </cube-scroll>
      </div>
      <div class="bottom-btn">
        <button @click="handleClickOne" class="theme-button" :disabled="!selectTokens.length">一键投递</button>
      </div>
<!--      <div class="bottom-btn" v-else>-->
<!--        <button class="theme-button" :disabled="!selectTokens.length">一键投递</button>-->
<!--        <div class="subscribe-con">-->
<!--          <WechatOpenSubscribe :templateIds="templateIds" @handleClick="subscribeDeliveryClick">-->
<!--            <template slot="subscribe-slot">-->
<!--              <script type="text/wxtag-template">-->
<!--                <style>-->
<!--                  .btn2 {-->
<!--                    width: 100%;-->
<!--                    height: 100px;-->
<!--                  }-->
<!--                </style>-->
<!--                <div class="btn2">可以聊</div>-->
<!--              </script>-->
<!--            </template>-->
<!--          </WechatOpenSubscribe>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </w-popup-show>
</template>

<script>
	import WPopupShow from '../../components/global/w-popup-show'
  import WechatOpenSubscribe from '../../components/wechat-open-subscribe/wechat-open-subscribe'
	import { jobsMixin } from '../../assets/js/mixin/jobs'
	import { envMixin } from '../../assets/js/mixin/global'
	import hr from '../../api/api-list/hr'
	import { componentsMixin } from '../../assets/js/mixin/components'
  import {ioMixin} from "../../assets/js/mixin/io";

	export default {
		name: 'job-send-success',
		props: {
			state: {
				type: Boolean,
				default: false
			},
			postList: {
				type: Array,
				default: () => []
			},
			source: {
				type: String,
				default: ''
			},
			cvs: {
				type: Array,
				default: () => []
			},
			cvIndex: {
				type: Number,
				default: 0
			},
      isSubscribe: {
			  type: Boolean,
        default: false
      },
      templateIds: {
			  type: Array,
        default: () => []
      }
		},
		mixins: [ envMixin, componentsMixin, ioMixin ],
		data () {
			return {
				checkedIndex: 0,
				moreState: false,
				boxChecked: false,
				selectTokens: []
			}
		},
		created () {
			this.selectTokens = this.postList.map(item => item.token)
		},
		computed: {},
		watch: {},
		filters: {
			degreeFilter (val) {
				if (!val) {
					return '学历不限'
				} else if (val.includes('不限')) {
					return '学历不限'
				} else {
					return val
				}
			},
			experienceFilter (val) {
				if (!val) {
					return '经验不限'
				} else if (val.includes('不限')) {
					return '经验不限'
				} else {
					return val
				}
			}
		},
		components: {
			WPopupShow,
      WechatOpenSubscribe
		},
		methods: {
		  // 关闭按钮订阅点击
      subscribeCloseClick() {
        this.handleClose()
      },
      // 一键投递按钮订阅点击
      subscribeDeliveryClick() {
        this.handleClickOne()
      },
			handleClose () {
				this.$emit('handleClose')
			},
			handleClickSelect (token) {
				if (this.selectTokens.includes(token)) {
					this.selectTokens.forEach((item, index) => {
						if (item === token) {
							this.selectTokens.splice(index, 1)
						}
					})
				} else {
					this.selectTokens.push(token)
				}
			},
			async handleClickOne () {
				try {
					this.$parent.loadingShow = true
					let urlRes = await this.$api.cv.downloadCv(this.cvs[this.cvIndex].token, { watermark: 'yes' })
					let res = await hr.oneKeyDeliver({
						job_tokens: this.selectTokens,
						cv_token: this.cvs[this.cvIndex].token,
						cv_url: urlRes.data.url,
            cv_source: 'bulk_m'
					})
					if (res.code === 1000) {
						this.$parent.loadingShow = false
						this.$emit('handleClose')
						this.$emit('on-toast', { imgUrl: 'https://files.wondercv.com/jobs/mailing.png', txt: '投递成功' })
            this.reportedData({
              data_type: 'job_delivery',
              data: {
                job_tokens: this.selectTokens
              }
            })
						this.postList.forEach(item => {
							if (item.origin_source === 'jd')
								this.$api.HrApi.jobsOperation({
									token: item.token,
									operation: 'apply'
								})
						})
					} else {
						this.$parent.loadingShow = false
					}
				} finally {
					this.$parent.loadingShow = false
				}
			},
			handleClickToDetail (item) {
				this.$emit('handleClose', 'jobDetail')
				if (this.iosOrAndroid) {
					window.location.href = `/jobs/${ item.token }.html`
				} else if (this.isWxMini && this.miniType === 'zhixuan') {
					this.$wechat.miniProgram.navigateTo({
						url: `/pages/jobDetail/jobDetail?url=${ process.env.VUE_APP_HOST }/jobs/recommend/${ item.token }&companyToken=${ item.company_token }&com_name=${ item.company_name }&info_name=${ item.job_post }&miniProgramType=zhixuan`
					})
				} else {
					this.$router.push({
						path: `/jobs/recommend/${ item.token }`,
						query: {
							companyToken: item.company_token
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";

  .mailing-content {
    width: 100vw;
    background-color: #fff;
    border-radius: 16px 16px 0 0;
    height: 571px;
    padding-top: 24px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-height: 571px;

    .close {
      height: 11px;
      padding-right: 25px;
      text-align: right;
      position: relative;
      .subscribe-con {
        position: absolute;
        top: 0;
        right: 25px;
        width: 16px;
        height: 16px;
        //background-color: red;
      }

      > i {
        color: #404040;
      }
    }

    .header {
      height: 80px;
      border-bottom: 6px solid #F9F9F9;
      display: flex;
      flex-direction: column;
      align-items: center;

      .text {
        display: flex;
        align-items: center;
        line-height: 25px;
        margin-bottom: 6px;

        > img {
          height: 20px;
        }

        > p {
          font-size: 18px;
          font-weight: 500;
          color: rgba(64, 64, 64, 1);
          white-space: nowrap;
        }
      }

      .source {
        font-size: 14px;
        font-weight: 400;
        color: rgba(188, 188, 188, 1);
      }
    }

    .correlation {
      height: 56px;
      padding-left: 24px;
      line-height: 56px;
      color: #404040;
      font-size: 16px;
      font-weight: 500;
    }

    .scroll-list-wrap {
      height: 368px;
    }

    .bottom-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 78px;
      background: rgba(255, 255, 255, 1);
      padding: 20px 24px;
      z-index: 999;

      .subscribe-con {
        position: absolute;
        top: 20px;
        right: 25px;
        width: 100%;
        height: 100%;
        //background-color: red;
      }

      > button {
        width: 327px;
        height: 38px;
        background: $color-theme;
        border-radius: 4px;
        text-align: center;
        line-height: 38px;
        color: #fff;
        font-size: $font-size-medium-x;
        &:disabled {
          color: #ffffff;
          background-color: #cfcfcf;
        }
      }
    }

    .post-item {
      width: 375px;
      height: 120px;
      padding: 20px 24px;
      position: relative;
      display: flex;

      &::after {
        content: '';
        left: 24px;
        right: 24px;
        height: 1px;
        background: #F9F9F9;
        position: absolute;
        bottom: 0;
      }

      ._box_1 {
        flex: 1;
      }

      .item-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;

        & > p:nth-of-type(1) {
          color: #404040;
          font-size: 16px;
          font-weight: 500;
          max-width: calc(100vw - 200px);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        & > p:nth-of-type(2) {
          color: $color-theme;
          font-size: 14px;
          font-weight: 500;
          flex: 1;
          text-align: right;
        }
      }

      .item-tags {
        display: flex;
        margin-bottom: 8px;

        .tag {
          height: 24px;
          padding: 6px 10px;
          background: rgba(249, 249, 249, 1);
          border-radius: 2px;
          color: #9C9C9C;
          font-size: 12px;
          font-weight: 300;
          margin-right: 6px;
        }
      }

      .company {
        height: 24px;
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          border-radius: 2px;
          margin-right: 10px;
          object-fit: contain;
        }

        > p {
          font-size: 14px;
          font-weight: 300;
          color: rgba(64, 64, 64, 1);
        }
      }

      .option {
        width: 44px;
        min-width: 44px;
        display: flex;
        align-items: center;

        > i {
          color: $color-theme;
        }
      }
    }

    .not-select {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid #BCBCBC;
    }
  }
</style>
